export enum DrillPileDepthSource {
  Machine = 'Machine',
  Manual = 'Manual'
}